import React, { useEffect, useState } from "react";
import styles from "./Credits.module.css";
import BusinessIcon from "@mui/icons-material/Business";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useDispatch, useSelector } from "react-redux";
import { customerActions } from "@_actions/customer.actions";
import InfoPopup from "@_components/popups/InfoPopup/InfoPopup";
import { Button } from "@mui/material";
import { sidebarConstants } from "@_constants/sidebar.constants";
import { sidebarActions } from "@_actions/sidebar.actions";

function Credits() {
  const dispatch = useDispatch();
  const customerReducer = useSelector((state) => state.customerReducer);
  const [openCreditsPopup, setOpenCreditsPopup] = useState(false);

  const handleOpenCreditsPopup = () => {
    setOpenCreditsPopup(true);
  };
  useEffect(() => {
    dispatch(customerActions.getCredits());
    dispatch(sidebarActions.updateStatus(sidebarConstants.CREDITS));
  }, [dispatch]);

  return (
    <div className={styles.root}>
      <div className={styles.account_title}>
        <BusinessIcon className={styles.business_icon} />
        <h2>Account </h2>
        <ArrowForwardIosIcon fontSize="small" className={styles.arrow_icon} />
        <h2>Credits</h2>
      </div>
      <div className={styles.credits_container}>
        <p>
          {" "}
          Balance: <b>{customerReducer.credits} credits</b>
        </p>
        <Button className="btn_confirm" onClick={handleOpenCreditsPopup}>
          Add Credits
        </Button>
      </div>
      <InfoPopup
        open={openCreditsPopup}
        title="Add Credits"
        close={() => setOpenCreditsPopup(false)}
      >
        <p>
          To purchase credits, please email the desired number of credits to{" "}
          <a href="mailto:support@fairlicensing.com">
            {" "}
            support@fairlicensing.com{" "}
          </a>
          .<br />
          <br />
          We will then send you an invoice for <b>1 Euro per credit</b> (plus
          VAT, if applicable).
          <br />
          Once we receive either the payment in full or a valid payment
          confirmation, the corresponding number of credits will be added to
          your account.
        </p>
      </InfoPopup>
    </div>
  );
}

export default Credits;
